import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { useUpdateOrganizationalInfoHiringMutation } from 'services/talento';

import { IAdminPanelForm } from './AdminPanelForm.schema';


export function useOrganizationalSubmit() {
  const { getValues } = useFormContext<IAdminPanelForm>();
  const { email } = useParams();
  const [updateOrganizationalInfoHiring] = useUpdateOrganizationalInfoHiringMutation();

  function toSapId(value?: string | null) {
    return value && value.trim() ? value : null;
  }

  async function submitOrganizational() {
    const { organizationalInformation, growInformation } = getValues();

    await updateOrganizationalInfoHiring({
      email: email ?? '',
      division: organizationalInformation.division,
      department: organizationalInformation.department,
      referred: organizationalInformation.referred,
      updateGrowRequest: growInformation.map((grow) => ({
        chapter: grow.chapter,
        idChapterSap: toSapId(grow.idChapterSap),
        specialty: grow.specialty,
        idSpecialtySap: toSapId(grow.idSpecialtySap),
        technology: grow.technology,
        idTechnologySap: toSapId(grow.idTechnologySap),
        technicaLevel: grow.technicaLevel,
        idTechnicalLevelSap: toSapId(grow.idTechnicalLevelSap),
        position: grow.position ?? 0,
      })),
    }).unwrap();
  }

  return submitOrganizational;
}
